// Color utilities for MaterialUI Theme/Styles

export const blue = {
  100: '#eaf3f8', // hover
  200: '#89cbdf',
  300: '#00aafc',
  400: '#0092e0',
  500: '#0084ba',
  600: '#006da8',
  700: '#074F86', // primary
  800: '#00223C'
};

export const neutral = {
  100: '#ffffff',
  200: '#efefef',
  300: '#d1cece',
  400: '#c6c4c4',
  500: '#8a8a8a',
  550: '#7f7f7f',
  600: '#4f4f4f',
  700: '#000000'
};

export const status = {
  success: {
    light: '#dff0d0', // p2 fill
    medium: '#65B500', // p2 border
    dark: '#04844B' // p1 fill
  },
  error: {
    light: '#f5dbd9',
    medium: '#ebafa6',
    dark: '#c92100'
  },
  warning: {
    light: '#ffeadb',
    medium: '#ff7e1c',
    dark: '#C25400'
  },
  info: {
    light: '#e1f1f6',
    medium: '#89cbdf',
    dark: '#007cbb'
  },
  deactive: '#8a8a8a'
};

/** Other colors from _colors.scss */
export const colors = {
  rustRed: '#c92100',
  lightGrey: '#dadada'
};
